import { themeVariables } from "Components/theme";
import classNames from "classnames";
import React, { useMemo } from "react";
export default function TextWithColorMark(props) {
    const markStyle = useMemo(() => ({
        height: props.markSize,
        width: props.markSize,
        backgroundColor: themeVariables[props.color] || props.color,
        borderRadius: Math.floor(props.markSize / 2)
    }), [props.markSize, props.color]);
    return (React.createElement("div", { className: classNames("grid-cols-auto no-gap", props.className) },
        React.createElement("div", { style: markStyle }),
        React.createElement("div", { className: classNames("text-overflow-ellipsis", props.titleWrap && "pre-wrap", props.titleClassName, props.titleMarginLeftClassName) }, props.title)));
}
TextWithColorMark.defaultProps = {
    markSize: 6,
    titleWrap: true,
    titleMarginLeftClassName: "ml-1"
};
